export default __webpack_public_path__ + "static/media/violin.e208bda3.jpg";